import { render, staticRenderFns } from "./Virtualdetail.vue?vue&type=template&id=48feb27b&scoped=true&"
import script from "./Virtualdetail.vue?vue&type=script&lang=js&"
export * from "./Virtualdetail.vue?vue&type=script&lang=js&"
import style0 from "./Virtualdetail.vue?vue&type=style&index=0&id=48feb27b&lang=scss&scoped=true&"
import style1 from "./Virtualdetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48feb27b",
  null
  
)

export default component.exports